export class FinnishSSN {
  ssn: string;

  constructor(ssn: string) {
    this.ssn = ssn;
  }

  validateSSN = (gender?: "male" | "female") => {
    const ssnRegex = /^(\d{2})(\d{2})(\d{2})([+\-A])(\d{3})([0-9A-Y])$/.exec(
      this.ssn,
    );

    if (!ssnRegex) return false;

    const [_fullString, day, month, year, centurySign, individual, checksum] =
      ssnRegex;
    const fullYear = () => {
      switch (centurySign) {
        case "+":
          return `18${year}`;
        case "-":
          return `19${year}`;
        case "A":
          return `20${year}`;
        default:
          return null;
      }
    };
    if (!fullYear()) return false;

    const individualNum = Number(individual);
    if (Number.isNaN(individualNum)) {
      return false;
    }

    if (gender === "female" && individualNum % 2 !== 0) {
      return false;
    }
    if (gender === "male" && individualNum % 2 === 0) {
      return false;
    }
    const checksumSource = Number(`${day}${month}${year}${individual}`);
    const checksumChars = "0123456789ABCDEFHJKLMNPRSTUVWXY"; // 31 characters
    const expectedChecksum = checksumChars[checksumSource % 31];

    return checksum.toUpperCase() === expectedChecksum;
  };
  validateMaleSSN = () => this.validateSSN("male");
  validateFemaleSSN = () => this.validateSSN("female");
}

export const validSSN = (ssn: string | undefined): boolean => {
  if (!ssn) {
    return false;
  }
  const finnishSSN = new FinnishSSN(ssn);
  return finnishSSN.validateSSN();
};
